import { AutocompletePrefix, MarkType } from '$lib/enums';

export const AUTOCOMPLETE_PREFIXES: readonly AutocompletePrefix[] = [
	AutocompletePrefix.ROOM_MENTION,
	AutocompletePrefix.USER_MENTION,
	AutocompletePrefix.EMOTICON,
	AutocompletePrefix.COMMAND
];

/** Innermost-first wrap order of the custom HTML output (Slate leaf rendering order). */
export const EDITOR_MARK_ORDER: readonly MarkType[] = [
	MarkType.BOLD,
	MarkType.ITALIC,
	MarkType.UNDERLINE,
	MarkType.STRIKE_THROUGH,
	MarkType.CODE,
	MarkType.SPOILER
];

export const EDITOR_DEFAULT_MAX_HEIGHT = '50vh';

export const EDITOR_AUTOCOMPLETE_LIMIT = 20;

export const EDITOR_RECENT_EMOJI_LIMIT = 20;

export const EDITOR_MEMBER_SEARCH_LIMIT = 1000;

export const EDITOR_AVATAR_SIZE = 32;
